import { render, staticRenderFns } from "./staffRequests.vue?vue&type=template&id=3ad8f5a0&scoped=true&"
import script from "./staffRequests.vue?vue&type=script&lang=js&"
export * from "./staffRequests.vue?vue&type=script&lang=js&"
import style0 from "./staffRequests.vue?vue&type=style&index=0&id=3ad8f5a0&lang=scss&scoped=true&"
import style1 from "./staffRequests.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8f5a0",
  null
  
)

export default component.exports